// @ts-nocheck
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'
import { getOrganizations } from 'src/redux/slices/user/endpoints'
import { selectUserId } from 'src/redux/slices/user/selectors'

import { Box, Divider, Grid, Typography } from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

import PendingInviteList from '../components/PendingInviteList'
import TeamCreator from '../components/TeamCreator'
import TeamOverview from '../components/TeamOverview'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paragraph: {
      marginBottom: '1rem',
    },
    divider: {
      marginBottom: '1rem',
      marginTop: '1rem',
    },
  }),
)

const TeamsPage: React.FC = () => {
  const { data } = getOrganizations.useQuery('')
  const uid = useSelector(selectUserId)
  const classes = useStyles()
  useTabNavigation()
  return (
    <Box>
      <Divider className={classes.divider} />
      <Typography variant='body2' className={classes.paragraph}>
        A Team represents a group of people who will be working on a series of Pojects, aka Studies,
        together. Each team should ideally have one sustainability champion who is responsible for
        coordinating the team members and setting the scope of the project, one GIS manager who is
        responsible for supplying validated GIS files and identifying key fields within those files,
        and an energy modeler who is responsible for segmenting the building stock into archetypes
        and assigning building simulation templates to those archetypes.
      </Typography>
      <Typography variant='body2' className={classes.paragraph}>
        Each project (or study) will involve building a baseline UBEM from a seed GIS file and then
        defining upgrade scenarios which will be simulated to test their carbon and energy impact.
        All members of your team will be able to view and edit each of the studies associated with
        the team, making it easy to move from an initial small seed UBEM to a full urban scale UBEM
        by carrying over settings from one study to the next.
      </Typography>
      <Typography variant='body2' className={classes.paragraph}>
        Once you have created a new Team, head over to the{' '}
        <Link to='/account/projects'>Projects tab</Link> to create a new project and start your
        UBEM!
      </Typography>
      <Divider className={classes.divider} />
      {data?.length === 0 && (
        <>
          <Typography variant='h5'>Create a Team to get started!</Typography>
          <Divider className={classes.divider} />
        </>
      )}
      <TeamCreator />
      <Divider className={classes.divider} />
      <PendingInviteList />
      <Divider className={classes.divider} />
      {(data?.length ?? 0) > 0 && (
        <Grid spacing={2} container>
          {data?.map(
            ({ organization_id, title, id: members }) =>
              members?.filter(({ user_id }) => user_id?.id === uid).length > 0 && (
                <TeamOverview
                  key={`organization-${organization_id}`}
                  title={title}
                  organization_id={organization_id}
                  members={members}
                />
              ),
          )}
        </Grid>
      )}
    </Box>
  )
}

export default TeamsPage
